import LogicFlow from "@logicflow/core";
import { BaseNodeModel, Model } from "@logicflow/core/lib/model";
import { ReactNodeProps } from "@logicflow/react-node-registry";
import FlowNode, { FlowNodeModel } from "./node/Index";
import { StopIcon } from "./Icon";
import CardHeader from "./node/header/Index";

export class StopNodeModel extends FlowNodeModel {
  initNodeData(data: LogicFlow.NodeConfig): void {
    super.initNodeData(data);
    this.sourceRules = [
      {
        message: "The stop node cannot accept any output.",
        validate: () => {
          return false;
        },
      },
    ];
    this.targetRules = [
      {
        message: "Input cannot have incomming connections.",
        validate: (
          _sourceNode?: BaseNodeModel,
          _targetNode?: BaseNodeModel,
          sourceAnchor?: Model.AnchorConfig,
          _targetAnchor?: Model.AnchorConfig
        ) => {
          return sourceAnchor?.type === "outgoing";
        },
      },
      {
        message: "Stop node can only accept one input.",
        validate: (
          _sourceNode?: BaseNodeModel,
          targetNode?: BaseNodeModel,
          _sourceAnchor?: Model.AnchorConfig,
          _targetAnchor?: Model.AnchorConfig
        ) => {
          if (!targetNode) {
            return true;
          }

          const edges = this.graphModel.getNodeIncomingEdge(targetNode.id);
          return edges.length === 0;
        },
      },
    ];
  }

  getDefaultAnchor(): Model.AnchorConfig[] {
    const { id, x, y, width } = this;
    const anchors = [];
    anchors.push({
      x: x - width / 2,
      y,
      id: `${id}_incomming`,
      type: "incomming",
    });
    return anchors;
  }
}

export default function StopNode({ node, graph }: ReactNodeProps) {
  return (
    <FlowNode node={node} graph={graph} type="stop-node">
      <CardHeader Icon={StopIcon} title="Stop"></CardHeader>
    </FlowNode>
  );
}
